module.exports = __webpack_public_path__ + "static/assets/d31c9fce7783419ec055ee148c4ac160.jpg";